import React from "react";
import Chip from "@hyro-components/Chip";
import { COUNT_CHIP_SX } from "./ReviewChangesDialog.styles";

const CountChip = ({ count, active = false }) => (
  <Chip
    label={count}
    backgroundColorPath={active ? ["tertiary", 300] : ["system", 100]}
    textColorPath={active ? ["primary", 500] : ["text", 700]}
    sx={COUNT_CHIP_SX}
  />
);

export default CountChip;
